import React from "react";
import { HStack, SimpleGrid, Text } from "@chakra-ui/react";
import { format, formatDistanceToNowStrict } from "date-fns";

import { useUser } from "context/user";
import { isCancelledSession, isFutureSession } from "utils/session";
import { Callback, Session } from "types";
import { UserRole } from "types/user";
import { LineIcon } from "components/Icons";
import { CalendarLink, Card } from "components";
import SessionActions from "./SessionActions";
import StatusTag from "./StatusTag";
import { GetCommaSeperatedClientList } from "utils/user";
interface Props {
  session: Session;
}

const SessionRow: React.FC<Props> = ({ session }: Props) => {
  const { user: actor } = useUser()!;
  const { title, participants, coach, start_time, end_time } = session;
  return (
    <Card>
      <SimpleGrid gap={4} columns={2} templateColumns="1fr fit-content(100%)">
        <HStack alignItems="center">
          <Text fontSize="2xl" fontWeight="bold">
            {title}
          </Text>
          <Text
            fontSize="lg"
            fontWeight="thin"
          >{`w/ ${GetCommaSeperatedClientList(participants, coach)}`}</Text>
          <SessionActions session={session} />
        </HStack>
        <HStack justifyContent="flex-end">
          {isFutureSession(session) && !isCancelledSession(session) && (
            <CalendarLink session={session} />
          )}
          <StatusTag status={session.status} />
          {actor.privs >= UserRole.Admin && !session.billable && (
            <StatusTag status="Not Billable" />
          )}
        </HStack>
        <HStack spacing={2} fontWeight="light">
          {actor.privs > UserRole.Coach && (
            <>
              <Text>
                {coach && `Coach ${coach.first_name} ${coach.last_name}`}
              </Text>
              <LineIcon color="blue.500" />
            </>
          )}
          <Text>{`${format(new Date(start_time), "p")} - ${format(
            new Date(end_time),
            "p"
          )}`}</Text>
        </HStack>
        <Text fontWeight="light" justifySelf="flex-end">
          {`${format(new Date(start_time), "PP")}`}
        </Text>
      </SimpleGrid>
    </Card>
  );
};

export default SessionRow;
